import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/sharp-solid-svg-icons/faQuestionCircle';

import { FlexRow } from 'ui-components/components/flex';
import { Tooltip } from 'ui-components/components/tooltip';

import FormattedCurrency from '../../../../../../../components/formatted-currency';

import style from '../style.module.less';

/**
 * @param {object} props
 * @param {import('react-intl').MessageDescriptor} props.labelMessage - The label message descriptor
 * @param {import('react-intl').MessageDescriptor} [props.toolTipMessage] - Optional tooltip message descriptor
 * @param {{value: number, code: string}} props.currency - Currency object with value and code
 * @param {boolean} [props.hideValueWhenZero] - Whether to hide the value when it's zero
 * @returns {React.ReactElement} The amount summary row component
 */
export const AmountSummaryRow = ({ labelMessage, toolTipMessage, currency, hideValueWhenZero = false }) => {
  const { value, code } = currency;

  const shouldHideValue = hideValueWhenZero && value === 0;

  return (
    <FlexRow className={style['amount-summary-row-container']}>
      <label className={toolTipMessage ? style['amount-summary-row-label-with-icon'] : style['amount-summary-row-label']}>
        <FormattedMessage {...labelMessage} />
        {toolTipMessage && (
          <Tooltip position='bottom' text={<FormattedMessage {...toolTipMessage} />}>
            <FontAwesomeIcon className={style['amount-summary-row-icon']} icon={faQuestionCircle} />
          </Tooltip>
        )}
      </label>
      {!shouldHideValue && (
        <div>
          <FormattedCurrency currencyCode={code} value={value} />
        </div>
      )}
    </FlexRow>
  );
};
